export interface JobAid {
  label: string;
  url:   string;
}

export interface VideoItem {
  title:        string;
  description:  string;
  duration:     string;
  url:          string | null;
  thumbnailUrl?: string | null;
  jobAids?:     JobAid[];
}

export const VIDEOS: VideoItem[] = [
  {
    title:       "AI Analytics",
    description: "Get an overview of your dashboard's key performance indicators and outcome measures, and learn how to navigate directly to candidate tracking sections and the Find Your Ohio LinkedIn Candidate Tracker from the AI Analytics page.",
    duration:    "1:29",
    url:         "https://player.vimeo.com/video/1201820564?h=f2c4f751d9",
    thumbnailUrl: "https://i.vimeocdn.com/video/2169252289-247219499e6e75ebeec2c412878a66191cf6271a599cef8176ab6304267671f7-d_295x166?region=us",
    jobAids: [
      { label: "Job Aid", url: "https://app.box.com/shared/static/hskh7wg7nqpqjfkhyjow7nkrpmra6k77.pdf" },
    ],
  },
  {
    title:       "Referral Companies",
    description: "Learn how to access the Referral Companies directory and search for companies by name, industry vertical, client owner, or missing LinkedIn status.",
    duration:    "1:53",
    url:         "https://player.vimeo.com/video/1204215005?h=d118db5300",
    thumbnailUrl: "https://i.vimeocdn.com/video/2172496376-0ae7ac2fc55defc279b4dac86a97463131c5fcba208b7a260019aa765c650d9b-d_295x166?region=us",
    jobAids: [
      { label: "Job Aid", url: "https://app.box.com/shared/static/y5izu55cbaeaq3wi5jweq6j8fqkutrcs.pdf" },
    ],
  },
  {
    title:       "Candidates",
    description: "Learn how to access the Candidates page, search and filter tracked candidates by name or state, and apply or reset your results.",
    duration:    "1:53",
    url:         "https://player.vimeo.com/video/1204218572?h=3195b3153f",
    thumbnailUrl: "https://i.vimeocdn.com/video/2172501155-76b3c675daba7ff1cf67d5c84d18eebb7baff4e03c27e77247eb3e4b12de21db-d_295x166?region=us",
    jobAids: [
      { label: "Job Aid", url: "https://app.box.com/shared/static/61nluvtkpy575ki3lmxi7fm1h20t3bq4.pdf" },
    ],
  },
  {
    title:       "Placements",
    description: "Understand how Find Your Ohio candidates are tracked across Direct Placement, Influenced Relocation, and Influenced Placement, and how to navigate each section.",
    duration:    "3:34",
    url:         "https://player.vimeo.com/video/1204238187?h=dc6399678c",
    thumbnailUrl: "https://i.vimeocdn.com/video/2172526101-9ef205a0d5b2b368e458cce830ab5eb26227c250f77f32c40a345b71f3f63d15-d_295x166?region=us",
    jobAids: [
      { label: "Direct Placement",      url: "https://app.box.com/shared/static/h1fm2e80snpoxxy5p0iwtwmwsog7f47s.pdf" },
      { label: "Influenced Relocation", url: "https://app.box.com/shared/static/r4vh4r50mbfn3zlqfvpveshh3j1owpve.pdf" },
      { label: "Influenced Placement",  url: "https://app.box.com/shared/static/e57ysrc8fozlt2yw8ymclmvuce9lj27d.pdf" },
    ],
  },
  {
    title:       "Feedback",
    description: "Discover how to submit tool feedback using the feedback form and find the right contact for Find Your Ohio or AI Ready Ohio program-specific questions.",
    duration:    "TBD",
    url:         null,
    jobAids: [
      { label: "Job Aid", url: "https://app.box.com/shared/static/qit0atut1dlac6v3t8rh9qagxksq21ma.pdf" },
    ],
  },
];
